import { render, staticRenderFns } from "./StateTypeAppraisal.vue?vue&type=template&id=b55bc8b8&scoped=true&"
import script from "./StateTypeAppraisal.vue?vue&type=script&lang=js&"
export * from "./StateTypeAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./StateTypeAppraisal.vue?vue&type=style&index=0&id=b55bc8b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55bc8b8",
  null
  
)

export default component.exports